import { createApi } from '@reduxjs/toolkit/query/react';
//
import { customBaseQuery } from '../../auth/context/jwt/utils';
import { ISupplier, ISupplierCreate, ISupplierPage } from '../../types/supplier';

const path = 'suppliers';

type UpdateProps = {
  data: ISupplierCreate;
  id: number;
};

export const supplierService = createApi({
  reducerPath: 'supplierService',
  tagTypes: ['suppliers'],
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getSuppliers: builder.query<ISupplierPage, Record<string, any>>({
      query: (params) => ({
        url: `/${path}/list`,
        params,
      }),
      providesTags: ['suppliers'],
    }),

    getSupplier: builder.query<ISupplier, number>({
      query: (id: number) => ({
        url: `/${path}/findById/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'suppliers', id }],
    }),

    getNextCode: builder.query<{ code: string }, void>({
      query: () => ({
        url: `/${path}/nextCode`,
        method: 'GET',
      }),
    }),

    saveSupplier: builder.mutation<ISupplier, ISupplierCreate>({
      query: (supplier: ISupplierCreate) => ({
        url: `/${path}/insert`,
        method: 'POST',
        body: supplier,
      }),
      invalidatesTags: ['suppliers'],
    }),

    updateSupplier: builder.mutation<ISupplier, UpdateProps>({
      query: ({ id, data }: UpdateProps) => ({
        url: `/${path}/update/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => ['suppliers', { type: 'suppliers', id }],
    }),

    deleteSupplier: builder.mutation<{ message: string }, number>({
      query: (id: number) => ({
        url: `/${path}/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['suppliers'],
    }),

    toggleSupplierStatus: builder.mutation<ISupplier, number>({
      query: (id: number) => ({
        url: `/${path}/${id}/toggle-status`,
        method: 'PATCH',
      }),
      invalidatesTags: ['suppliers'],
    }),
  }),
});

export const {
  useGetSuppliersQuery,
  useGetSupplierQuery,
  useLazyGetSupplierQuery,
  useGetNextCodeQuery,
  useSaveSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
  useToggleSupplierStatusMutation,
} = supplierService;
